module.exports = __webpack_public_path__ + "static/media/material_icon_send.2c4c259e.svg";